export const conditionRuleTypes = {
    SHOW_IF: 'SHOW_IF',
    HIDE_IF: 'HIDE_IF',
    REQUIRE_IF: 'REQUIRE_IF',
    READONLY_IF: 'READONLY_IF',
};

export const conditionRuleTypeOptions = [
    { id: conditionRuleTypes.SHOW_IF, name: 'Show this field if', group: 'visibility' },
    { id: conditionRuleTypes.HIDE_IF, name: 'Hide this field if', group: 'visibility' },
    { id: conditionRuleTypes.REQUIRE_IF, name: 'Make required if', group: 'validation' },
    { id: conditionRuleTypes.READONLY_IF, name: 'Make read-only if', group: 'validation' },
];

export const conditionOperators = {
    IS: 'IS',
    IS_NOT: 'IS_NOT',
    IS_EMPTY: 'IS_EMPTY',
    IS_NOT_EMPTY: 'IS_NOT_EMPTY',
    IS_ONE_OF: 'IS_ONE_OF',
    IS_NONE_OF: 'IS_NONE_OF',
};

export const conditionOperatorOptions = [
    { id: conditionOperators.IS, name: 'is' },
    { id: conditionOperators.IS_NOT, name: 'is not' },
    { id: conditionOperators.IS_EMPTY, name: 'is empty' },
    { id: conditionOperators.IS_NOT_EMPTY, name: 'is not empty' },
    { id: conditionOperators.IS_ONE_OF, name: 'is one of' },
    { id: conditionOperators.IS_NONE_OF, name: 'is none of' },
];

/** Operators that don't require a value input */
export const valuelessOperators = [conditionOperators.IS_EMPTY, conditionOperators.IS_NOT_EMPTY];

/** Operators that accept multiple values */
export const multiValueOperators = [conditionOperators.IS_ONE_OF, conditionOperators.IS_NONE_OF];
